import { RoomCleanStatus, RoomMainStatus } from '@/config/constant';

const REALTIME_NAME_SPACE = 'REAL_TIME_STATE@';
const FUTURE_NAME_SPACE = 'FUTURE_TIME_STATE@';

// 实时房态排序顺序
export enum OrderOption {
  floorNo = '0',
  roomType = '1',
  roomState = '2',
}

// 实时房态视图
export enum ViewOption {
  roomState,
  billInfo,
  computerInfo,
  remarkInfo,
  roomTag,
}

export const AllRoomTypeSymbol = 'All_ROOM_TYPE_SYMBOL'; // 全部房型
export const EmptyRoomTypeSymbol = 'EMPTY_ROOM_TYPE_SYMBOL'; // 空房型
export const FastFilterTypeSymbol = 'FAST_FILTER_TYPE_SYMBOL'; // 快捷筛选
export const DirtyRoomSymbol = 'DIRTY_ROOM_SYMBOL'; // 脏房
export const AllRoomStatusSymbol = 'ALL_ROOM_STATUS_SYMBOL'; // 全部状态

export enum FastFilterType {
  AllRoom = -1, // 全部房间
  ExpectedDeparture = 0, // 预离
  ExpectedArrival = 1, // 预抵
  DepositInUse = 2, // 押金使用中
  InsufficientAdvance = 3, // 预付款不足
  Arrearage = 4, // 已欠费
}

export enum StatusFilterKeyConfig {
  VacantClean, // 空净
  VacantDirty, // 空脏
  Reserved, // 预订
  OccupiedClean, // 住净
  OccupiedDirty, // 住脏
  OutService, // 停用
}

export const FilterParamsConfig = {
  [StatusFilterKeyConfig.VacantClean]: {
    mainStatus: RoomMainStatus.Vacant,
    cleanStatus: RoomCleanStatus.Clean,
  },
  [StatusFilterKeyConfig.VacantDirty]: {
    mainStatus: RoomMainStatus.Vacant,
    cleanStatus: RoomCleanStatus.Dirty,
  },
  [StatusFilterKeyConfig.Reserved]: {
    mainStatus: RoomMainStatus.Reserved,
  },
  [StatusFilterKeyConfig.OccupiedClean]: {
    mainStatus: RoomMainStatus.Occupied,
    cleanStatus: RoomCleanStatus.Clean,
  },
  [StatusFilterKeyConfig.OccupiedDirty]: {
    mainStatus: RoomMainStatus.Occupied,
    cleanStatus: RoomCleanStatus.Dirty,
  },
  [StatusFilterKeyConfig.OutService]: {
    mainStatus: RoomMainStatus.OutService,
  },
};

const createRealtimeAction = (action) => {
  return `${REALTIME_NAME_SPACE}${action}`;
};

const createFutureAction = (action) => {
  return `${FUTURE_NAME_SPACE}${action}`;
};

export const RealTimeAction = {
  initUserConfig: createRealtimeAction('INIT_USER_CONFIG'),
  setRoomStateData: createRealtimeAction('SET_ROOM_STATE_DATA'),
  setFilterSearchText: createRealtimeAction('SET_FILTER_SEARCH_TEXT'),
  setFilterFastType: createRealtimeAction('SET_FILTER_FAST_TYPE'),
  setFilterRoomStatus: createRealtimeAction('SET_FILTER_ROOM_STATUS'),
  setFilterRoomType: createRealtimeAction('SET_FILTER_ROOM_TYPE'),
  setFilterChannel: createRealtimeAction('SET_FILTER_CHANNEL'),
  setOrderType: createRealtimeAction('SET_ORDER_TYPE'),
  setViewType: createRealtimeAction('SET_VIEW_TYPE'),
  setTodoFoldStatus: createRealtimeAction('SET_TODO_FOLD'),
  setBusinessDate: createRealtimeAction('SET_BUSINESS_DATE'),
  setChannelList: createRealtimeAction('SET_CHANNEL_LIST'),
  setCardStatus: createRealtimeAction('SET_CARD_MANAGE_STATUS'),
};

export const FutureTimeAction = {
  setLoadingStatus: createFutureAction('SET_LOADING_STATUS'),
  setBusinessDate: createFutureAction('SET_BUSINESS_DATE'),
  setNightAuditTime: createFutureAction('SET_NIGHT_AUDIT_TIME'),
  setChannelList: createFutureAction('SET_CHANNEL_LIST'),
  setCalendarDateRange: createFutureAction('SET_CALENDAR_DATE_RANGE'),
  setFutureRoomData: createFutureAction('SET_FUTURE_ROOM_DATA'),
  setFoldRoomData: createFutureAction('SET_FOLD_ROOM_DATA'),
};
